import React from "react";
import { Navigate, useParams } from "react-router-dom";
import { usePermissions } from "../../Hooks/usePermissions";
import PrivateRoutes from "./PrivateRoutes";

/*
 * Until the server has said who is signed in there is nothing to judge, so
 * the gate inside PrivateRoutes shows and the page waits. Judging a missing
 * profile as "not a super admin" sent super admins to the dashboard on a
 * cold boot.
 */

export const SuperAdminRoute = ({ children, redirectTo = "/dashboard" }) => {
  const { isSuperAdmin, profile } = usePermissions();
  if (!profile) return <PrivateRoutes />;
  if (!isSuperAdmin) return <Navigate to={redirectTo} replace />;
  return <PrivateRoutes>{children}</PrivateRoutes>;
};

export const SelfOrSuperAdminRoute = ({ children, redirectTo = "/dashboard" }) => {
  const { id } = useParams();
  const { isSuperAdmin, currentUserId, profile } = usePermissions();
  if (!profile) return <PrivateRoutes />;
  const targetId = Number(id);
  const isSelf = Number.isFinite(targetId) && targetId === currentUserId;
  if (!isSuperAdmin && !isSelf) return <Navigate to={redirectTo} replace />;
  return <PrivateRoutes>{children}</PrivateRoutes>;
};
